import { createSlice, createSelector } from "@reduxjs/toolkit";

// Base accessories each game always has
const BASE_ACCESSORIES = {
  comfort: ['Blindfold', 'Ice'],
  explore: ['Blindfold', 'Ice'],
  open: ['Blindfold', 'Ice'],
  demo: ['Blindfold', 'Ice'],
};

// All accessories that *can* be used per game
const ALL_ACCESSORIES_BY_GAME = {
  comfort: ['Blindfold', 'Ice', 'Vibrator', 'Dildo', 'Buttplug', 'Handcuffs', 'Oil'],
  explore: ['Blindfold', 'Ice', 'Vibrator', 'Dildo', 'Buttplug', 'Handcuffs', 'Oil'],
  open: ['Blindfold', 'Ice', 'Vibrator', 'Dildo', 'Buttplug', 'Handcuffs', 'Oil'],
  demo: ['Blindfold', 'Ice', 'Handcuffs'],
};

// Which accessories each deck unlocks
const DECK_ACCESSORY_MAP = {
  extreme: ['Dildo', 'Buttplug'],
  oilplay: ['Oil'],
  control: ['Handcuffs'],
  sensations: ['Vibrator'],
};

const accessoriesSlice = createSlice({
  name: "accessories",
  initialState: {
    // no need to store anything, selectors will compute it
  },
  reducers: {
    // No reducers needed for now
  },
});

// Selector: Computes available accessories per game based on owned decks in auth
const computeAccessoriesForGame = (gameType, decks) => {
  const base = BASE_ACCESSORIES[gameType] || [];
  const all = ALL_ACCESSORIES_BY_GAME[gameType] || [];

  const unlocked = new Set(base);

  decks?.forEach(deck => {
    const accessories = DECK_ACCESSORY_MAP[deck.toLowerCase()];
    if (accessories) {
      accessories.forEach(acc => {
        if (all.includes(acc)) {
          unlocked.add(acc);
        }
      });
    }
  });

  return Array.from(unlocked);
};

// Public selector — gets all accessories by game
export const selectAccessories = createSelector(
    [(state) => state.auth?.user?.decks || []],
    (decks) => {
      return {
        comfort: computeAccessoriesForGame("comfort", decks),
        explore: computeAccessoriesForGame("explore", decks),
        open: computeAccessoriesForGame("open", decks),
        demo: computeAccessoriesForGame("demo", decks),
      };
    }
  );

export default accessoriesSlice.reducer;
